import { Type } from '@angular/core';
import { LayoutComponent } from 'app/views/presentations/layouts/layout.component';

export abstract class Layout {
    public abstract type: string;
    public abstract componentType: Type<LayoutComponent>;
    public abstract numberOfSections: number;
    public supported: boolean = true;
}


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layout.ts